<p-button
  (click)="openScanner()"
  styleClass="rounded-xs text-xs m-0 p-1 h-full"
  icon="pi pi-barcode"
  iconPos="top"
  label="Scan"
/>

@if (isScannerOpen) {
  <div class="fixed inset-0 bg-black/70 flex justify-center items-center z-[1000]">
    <div class="bg-white p-5 rounded-lg flex flex-col items-center gap-2">
      <video #videoElement autoplay class="w-[300px] h-auto border-2 border-(--p-primary-500) rounded-lg">
      </video>
      <p-button (click)="closeScanner()" icon="pi pi-times"/>
    </div>
  </div>
}
